const deliveryConfig = {
    delivery:{
        writeFunc: 'updateShippingCosts',
        writeLayouts: ['DeliveryWriteDefaultLayout'],
        writeApiParamSet: {},
        parsingData: {
            shipping_cost_detail :'os_limit', // 배송비 상세 설정
            shipping_cost : 'os_shipping', // 기본 배송비
            deliveryKey : 'os_idx' // 배송비 키
        },
        writeSuccessType: 1,
        writeFailTypes: {
        },
        writeFailMsg: '저장 실패하였습니다.',
        keyName: '',
        getFunc: 'getShippingCosts',
        detailApiParamSet: {},
    }
}

export default {
    methods: {
        returnDeliveryConfig(type) {
            return deliveryConfig[type];
        },
    },
    filterConfig: {

    },
}
